import { SATError, SATErrorType } from "@sadtx/sat-error";

// MARK:- Constants
// SATError.message는 지역화된 문구 뒤에 서버 원본 message가 괄호로 감싸져 붙는다.
// 서버 응답에 message가 없으면 HTTP 클라이언트의 개발자용 문구가 대신 들어간다.
// 예) "환자 정보를 찾을 수 없습니다.(Request failed with status code 400)"
const RAW_MESSAGE_SUFFIX_PATTERN = /\s*\([^()]*\)\s*$/;

// MARK:- unknown 분류 여부
// 매핑되지 않은 서버 코드나 분류 불가 에러는 UnknownError로 변환된다.
// 이 경우 팝업 문구를 예측할 수 없으므로 에러 코드를 함께 노출한다.
export const isUnknownError = (error: SATError): boolean =>
  error.type === SATErrorType.UnknownError;

// MARK:- 사용자 노출용 에러 문구
// 문구가 정상적으로 나오는 매핑된 에러는 끝에 붙은 원문 래핑만 제거한다.
// unknown 분류는 괄호 안에 에러 코드가 들어있을 수 있어 제거하지 않는다.
export const removeRawMessageSuffix = (message: string): string =>
  message.replace(RAW_MESSAGE_SUFFIX_PATTERN, "").trim();

// MARK:- 사용자 노출용 에러 코드
// 매핑되지 않은 서버 코드는 errorCode에 담기고, 없으면 type(999999)이 유일한 단서다.
export const getDisplayErrorCode = (error: SATError): string => error.errorCode ?? error.type;
